/**
 * HospitalDetail tool rendering component
 */

'use client';

import {
  Tool,
  ToolContent,
  ToolHeader,
  ToolInput,
  ToolOutput,
} from '../elements/tool';
import { pickLocaleName } from '../hospital-cards';
import type { HospitalDetailToolPart } from './types';

type HospitalDetailToolProps = {
  part: HospitalDetailToolPart;
};

export function HospitalDetailTool({ part }: HospitalDetailToolProps) {
  const { state, input, output } = part;

  // Output available
  if (state === 'output-available') {
    if (output?.error) {
      return (
        <Tool>
          <ToolHeader type="getHospitalDetail" state="output-error" />
          <ToolOutput errorText={output.error} />
        </Tool>
      );
    }

    if (!output?.found || !output?.hospital) {
      return null;
    }

    const h = output.hospital;
    return (
      <Tool>
        <ToolHeader type="getHospitalDetail" state="output-available" />
        <ToolContent>
          <div className="space-y-2 text-sm">
            <div className="font-semibold text-foreground">
              {pickLocaleName(h.name)}
            </div>
            <div className="text-muted-foreground">
              Location: {pickLocaleName(h.location)}
            </div>
            {h.phoneNumber && (
              <div className="text-muted-foreground">Phone: {h.phoneNumber}</div>
            )}
            {h.openingHours && (
              <div className="text-muted-foreground">
                Hours: {pickLocaleName(h.openingHours)}
              </div>
            )}
          </div>
        </ToolContent>
      </Tool>
    );
  }

  // Input streaming/available - show loading
  if (state === 'input-streaming' || state === 'input-available') {
    return (
      <Tool>
        <ToolHeader type="getHospitalDetail" state={state} />
        <ToolInput input={input} />
      </Tool>
    );
  }

  return null;
}
